import React, { useEffect, useState } from "react";
import "./SignModal.css";
import ReactDOM from "react-dom";
import { Link, Navigate } from "react-router-dom";
import CloseIcon from "@mui/icons-material/Close";

export default function SignModal({ closemodal }) {
  const [delmodalvalue, setDelModalValue] = useState("");
  const [isEnter, setIsEnter] = useState(false);

  const changeinput = (event) => {
    setDelModalValue(event.target.value);
  };

  const click = () => {
    setDelModalValue("");
  };
  const closeHandle = () => {
    setDelModalValue("");
  };

  useEffect(() => {
    const chekKey = (e) => {
      if (e.keyCode == 27) {
        closemodal();
      }
    };
    window.addEventListener("keydown", chekKey);
    return () => window.removeEventListener("keydown", chekKey);
  });
  useEffect(() => {
    const chekKey2 = (e) => {
      if (e.keyCode == 13 && delmodalvalue == 1) {
        setIsEnter(true);
      } else if (e.keyCode == 13) {
        setDelModalValue("");
      }
    };
    window.addEventListener("keydown", chekKey2);
    return () => window.removeEventListener("keydown", chekKey2);
  });

  return ReactDOM.createPortal(
    <div className="delemodal-container">
      <div className="delemodal-div">
        <div className="delemodal-closediv">
          <CloseIcon
            fontSize="inherit"
            className="delemodal-close"
            onClick={closemodal}
          />
        </div>
        <h1 className="delmodal-h1">لطفا رمز عبور را وارد کنید</h1>
        <input
          className="delmaoodal-input"
          type="text"
          value={delmodalvalue}
          onChange={changeinput}
        />
        <Link
          className="delmodal-link"
          onClick={click}
          to={delmodalvalue == 1 ? "/admin" : ""}
        >
          تایید
        </Link>
        {isEnter && <Navigate to={"/admin"} />}
      </div>
    </div>,
    document.getElementById("modals-parent")
  );
}
